export default "__VITE_ASSET__Bs$75L31__"